<template>
	<v-menu offset-y>
		<template #activator="{ on }">
			<v-btn icon v-on="on" v-show="deveExibirBotaoEstornar && !isAtaCancelada">
				<v-icon class="font-size-grande material-icons">mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list class="pa-1">
			<v-list-item
				class="list-item-height"
				data-testid="action-estornar"
				@click="$emit('estornar')"
				v-if="deveExibirBotaoEstornar"
				v-az-auth="permissoes.ataAdesaoItemEstornar"
			>
				<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-clipboard-arrow-left</v-icon>
				<v-list-item-title class="texto-menu-interno">Estornar</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>
<script>
import adesaoAta from '@/views/mixins/adesaoAta'
import permissoes from '@/core/constants/permissoes'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import tipos from '@/core/constants/tipos'
import { mapState } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'

export default {
	name: 'itens-adesao-btn-acoes',
	mixins: [adesaoAta, permissoesMixin, validacaoAta],
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			tamanhoIconeMenu: '18px',
		}
	},
	computed: {
		...mapState({
			adesao: (state) => state.adesao.informacoesAdesao || {},
		}),
		deveExibirBotaoEstornar() {
			return (
				this.item.tipoEstorno !== tipos.TIPO_ESTORNO_ITEM_ADESAO.ESTORNO_COMPLETO.value &&
				this.isPermissaoAutorizada(permissoes.ataAdesaoItemEstornar) &&
				this.verificarPermissao(permissoes.ataAdesaoItemEstornar) &&
				this.item.quantidadeSolicitada > 0 &&
				this.temPermissao &&
				this.isConcluida
			)
		},
		isAtaCancelada() {
			return this.estaCancelada(this.adesao.ataRegistroPreco?.situacao)
		},
	},
	mounted() {
		this.atualizaInstanciaDoProcesso()
	},
}
</script>
<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
